<template>
  <div class="leftSection">
    <div
      class="header-title wrapper-content__main font-size__large font-weight__bold"
    >
      {{ title }}
    </div>
    <div class="tagFilter">
      <span
        v-for="filterOption in filterOptions"
        :key="filterOption.value"
        :class="[filterOption.value === state ? 'active' : '', 'status-item']"
        @click="stateChanged(filterOption.value)"
      >
        <span>{{ filterOption.label }}</span>
        <span v-if="getCount(filterOption) > 0"
        >&nbsp;({{ getCount(filterOption) }})</span
        >
      </span>
    </div>
  </div>
</template>

<script>
  import constants from "../../../constants";
  import h from "../../../services/h";

  export default {
    name: "to-trinh-qua-han-state-filter",
    props: ["state", "title", "countOptions"],
    data() {
      return {
        DOC_USER_STATUS: constants.DOC_USER_STATUS,
        filterOptions: null
      };
    },

    created() {
      this.initFilterOptions();
    },

    methods: {
      getCount(filterOption) {
        if (!this.countOptions) return 0;
        let countOption = h.find(
          this.countOptions,
          item => item.value === filterOption.value
        );
        return countOption ? countOption.count : 0;
      },

      initFilterOptions() {
        this.filterOptions = h.collect(
          [
            constants.TO_TRINH_QUA_HAN.STATE.ALL,
            constants.TO_TRINH_QUA_HAN.STATE.CHUA_XU_LY,
            constants.TO_TRINH_QUA_HAN.STATE.DA_BINH_LUAN,
            constants.TO_TRINH_QUA_HAN.STATE.DA_XU_LY
          ],
          state => {
            return {
              value: state,
              label: this.buildLabel(state)
            };
          }
        );
      },

      buildLabel(state) {
        switch (state) {
          case constants.TO_TRINH_QUA_HAN.STATE.ALL:
            return "Tất cả";
          case constants.TO_TRINH_QUA_HAN.STATE.CHUA_XU_LY:
            return "Chưa xử lý";
          case constants.TO_TRINH_QUA_HAN.STATE.DA_XU_LY:
            return "Đã chuyển xử lý";
          case constants.TO_TRINH_QUA_HAN.STATE.DA_BINH_LUAN:
            return "Đã bình luận";
          default:
            return "";
        }
      },

      stateChanged(state) {
        this.$emit("stateChanged", {state: state});
      }
    }
  };
</script>

<style scoped>
  .leftSection {
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-in/to-trinh-qua-han/to-trinh-qua-han-state-filter.vue